// Shared theme colors — change here to update the entire app
export const theme = {
  primary: '#7A2020',
  primaryLight: '#9A3535',
  primaryDark: '#521515',
  primarySoft: '#E8C4C4',
  primaryDeep: '#3D0C0C',
  primaryRgb: '122, 32, 32',
  primaryLightRgb: '154, 53, 53',
} as const;
